import { render } from "./TermometriaComponent.vue?vue&type=template&id=104c547e"
import script from "./TermometriaComponent.vue?vue&type=script&lang=js"
export * from "./TermometriaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__